export default {
      id: "hourglass-end-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#hourglass-end",
      toString: function () {
        return this.url;
      }
    }